module.exports = __webpack_public_path__ + "media/application/images/ipad-small-c423ef3a061c517acd18929774366c00.png";